import { render, staticRenderFns } from "./aiGenerateKnowledge.vue?vue&type=template&id=edb6d0f8&scoped=true"
import script from "./aiGenerateKnowledge.vue?vue&type=script&lang=js"
export * from "./aiGenerateKnowledge.vue?vue&type=script&lang=js"
import style0 from "./aiGenerateKnowledge.vue?vue&type=style&index=0&id=edb6d0f8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "edb6d0f8",
  null
  
)

export default component.exports